import { render } from "./MainUsers.vue?vue&type=template&id=0af787f7&scoped=true"
import script from "./MainUsers.vue?vue&type=script&lang=js"
export * from "./MainUsers.vue?vue&type=script&lang=js"

import "./MainUsers.vue?vue&type=style&index=0&id=0af787f7&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af787f7"]])

export default __exports__